// update state
const setNotificationsCountAction = (payload) => {
    return {
        type: "NOTIFICATIONSCOUNT",
        payload
    }
}

export default setNotificationsCountAction;


// WEBPACK FOOTER //
// ./src/actions/setNotificationsCountAction.js